import UpdateGlobalCases from './UpdateGlobalCases';

export default UpdateGlobalCases;
